import { NgModule } from "@angular/core";
import { PPTranslatePipe } from "./pptranslate.pipe";
import { KeysPipe } from "./keys.pipe";
import { DistinctPipe } from "./distinct.pipe";
import { SortPipe } from "./sort.pipe";
import { OrderByDayPipe } from "./orderbyday.pipe";
import { SafePipe } from "./safe.pipe";
import { SecondsToTime } from "./seconds.time.pipe";

@NgModule({
  imports: [],
  declarations: [
    SecondsToTime,
    SafePipe,
    PPTranslatePipe,
    KeysPipe,
    DistinctPipe,
    SortPipe,
    OrderByDayPipe,
  ],
  exports: [
    SecondsToTime,
    SafePipe,
    PPTranslatePipe,
    KeysPipe,
    DistinctPipe,
    SortPipe,
    OrderByDayPipe,
  ],
})
export class PipeModule {
  static forRoot() {
    return {
      ngModule: PipeModule,
      providers: [],
    };
  }
}
